<div
  class="container-contract-list custom-contract"
  [class.contract-list--portal]="isPortalContractsPage"
>
  <div class="header">
    <div class="header__general">
      <h2 class="title" *ngIf="isExportable || isPortalContractsPage">
        Contracts
      </h2>

      <button
        *ngIf="isExportable"
        class="custom-btn export-file"
        [disabled]="isExportLoading"
        (click)="exportContracts()"
      >
        <img src="./assets/images/ic-export-white.svg" alt="export" />
        <span>Export Contracts</span>
        <i *ngIf="isExportLoading" class="fa-spin fas fa-spinner ms-2"></i>
      </button>
    </div>

    <app-table-filter-bar
      [basicParams]="brokerContractBasicParams"
      [searchByOptions]="search_by_options"
      [sortByOptions]="sorts"
      [filterByOptions]="FILTER_OPTIONS"
    ></app-table-filter-bar>
  </div>

  <p-tabView
    *ngIf="isBrokerContractsPage; else contractList"
    [activeIndex]="brokerContractTabIndex"
    (onChange)="onBrokerContractTabChange($event)"
  >
    <p-tabPanel *ngFor="let tab of brokerContractTabs; index as i" [header]="tab.label">
      <ng-container *ngIf="brokerContractTabIndex === i">
        <ng-template [ngTemplateOutlet]="contractList"></ng-template>
      </ng-container>
    </p-tabPanel>
  </p-tabView>

  <ng-template #contractList>
  <div class="contract-list-content">
    <div
      *ngIf="canShowBulkStatusChange && selectedContractIds.length"
      class="bulk-action-bar"
    >
      <span class="bulk-action-bar__count">
        {{ selectedContractIds.length }} selected
      </span>
      <div class="bulk-action-bar__actions">
        <button
          type="button"
          class="btn-bulk-change-status"
          (click)="openBulkChangeStatusModal()"
        >
          Change Status
        </button>
      </div>
    </div>

    <div class="custom-table">
      <table>
        <thead>
          <tr>
            <th scope="col" class="checkbox-col" *ngIf="canShowBulkStatusChange">
              <p-checkbox
                [binary]="true"
                [ngModel]="areAllSelected()"
                (ngModelChange)="toggleAllSelections($event)"
              ></p-checkbox>
            </th>
            <th scope="col" [hidden]="!tableSelected['Contract Number']">
              Contract Number
            </th>
            <th scope="col" [hidden]="!tableSelected['Contract Code']">
              Contract Code
            </th>
            <th scope="col" [hidden]="!tableSelected['Product Name']">
              Product Name
            </th>
            <!-- <th scope="col" [hidden]="!tableSelected['Contract Type']">Contract Type</th> -->
            <th scope="col" [hidden]="!tableSelected['Dealer']">Dealer</th>
            <th scope="col" [hidden]="!tableSelected['Customer Name']">
              Customer Name
            </th>
            <!-- <th scope="col" [hidden]="!tableSelected['Phone']">Phone #</th> -->
            <th scope="col" [hidden]="!tableSelected['Contract Date']">
              Contract Date
            </th>
            <th scope="col" [hidden]="!tableSelected['Contract Exp. Date']">
              Contract Exp. Date
            </th>
            <th scope="col" [hidden]="!tableSelected['Total Balance']">
              Total Balance
            </th>
            <th scope="col" [hidden]="!tableSelected['Total Remit.']">
              Total Remit.
            </th>
            <th scope="col" [hidden]="!tableSelected['Retail Cost']">
              Retail Cost
            </th>
            <th scope="col" [hidden]="!tableSelected['Status']">Status</th>
            <th scope="col" [hidden]="!tableSelected['Creation Method']">Creation Method</th>
            <!-- <th scope="col">SELLER</th> -->
            <th scope="col">
              <span>View PDF</span>
              <app-setting-dropdown
                [tableOptions]="tableOptions"
                [tableName]="tableName"
                (ChoosedOptions)="handleOutput($event)"
              ></app-setting-dropdown>
            </th>
          </tr>
        </thead>
        <tbody
          *ngIf="!isLoading && contractData.length > 0 && !serverErrorFetch"
        >
          <tr *ngFor="let contract of contractData; index as i">
            <td class="checkbox-col" *ngIf="canShowBulkStatusChange" data-thead="">
              <p-checkbox
                [binary]="true"
                [ngModel]="isSelected(contract?.id)"
                (ngModelChange)="onRowSelectionChange(contract?.id, $event)"
              ></p-checkbox>
            </td>
            <td-copied
              [data]="contract?.contract_number"
              [hidden]="!tableSelected['Contract Number']"
              [dataThead]="'Contract Number'"
            ></td-copied>
            <td
              data-thead="Contract Code"
              [hidden]="!tableSelected['Contract Code']"
            >
              {{ contract?.reference_code || '-' }}
            </td>
            <td
              data-thead="Product Name"
              [hidden]="!tableSelected['Product Name']"
            >
              {{ getContractProducts(contract?.products) || '-' }}
            </td>
            <!-- <td-copied [data]="contract?.type?.name" [dataThead]="'Contract Type'" [hidden]="!tableSelected['Contract Type']"></td-copied> -->
            <td data-thead="Dealer" [hidden]="!tableSelected['Dealer']">
              {{ contract?.dealer?.name ? (contract?.dealer?.name | allLettersCapital: true) : '-' }}
            </td>
            <td
              data-thead="CUSTOMER NAME"
              [hidden]="!tableSelected['Customer Name']"
            >
              {{ contract?.customers[0]?.name ? (contract?.customers[0]?.name | allLettersCapital: true) : '-' }}
            </td>
            <!-- <td data-thead="Phone #" [hidden]="!tableSelected['Phone']">{{contract?.customers[0]?.contact_details?.phone|phoneNumber}}</td> -->
            <td
              data-thead="CONTRACT DATE"
              [hidden]="!tableSelected['Contract Date']"
            >
              {{ contract?.start_date ? (contract?.start_date | formattedDate) : '-' }}
            </td>
            <td
              data-thead="CONTRACT EXP. DATE"
              [hidden]="!tableSelected['Contract Exp. Date']"
            >
              {{ contract?.expiry_date ? (contract?.expiry_date | formattedDate) : '-' }}
            </td>
            <td data-thead="Total Balance" [hidden]="!tableSelected['Total Balance']">
              {{ contract?.total_balance | formattedCurrency }}
            </td>
            <td data-thead="Total Remit." [hidden]="!tableSelected['Total Remit.']">
              {{ contract?.total_remit_amount | formattedCurrency }}
            </td>
            <td data-thead="Retail Cost" [hidden]="!tableSelected['Retail Cost']">
              {{ contract?.retail_cost | formattedCurrency }}
            </td>
            <!-- *ngIf="!(contract?.is_signed)" -->
            <td data-thead="STATUS" [hidden]="!tableSelected['Status']">
              <!-- <span [class]="'status '+ contract?.status">
                      {{ contract?.status | capitalizeFirstLetter }}
                    </span> -->
              <div
                class="status-tag"
                [ngStyle]="{
                  backgroundColor:
                    (contract?.status || '').toUpperCase() === 'ACTIVE'
                      ? 'green'
                      : (contract?.status || '').toUpperCase() ===
                        'PENDING CANCELLATION APPROVAL'
                      ? 'orange'
                      : (contract?.status || '').toUpperCase() === 'NEW'
                      ? 'blue'
                      : (contract?.status || '').toUpperCase() === 'VOID'
                      ? 'red'
                      : (contract?.status || '').toUpperCase() === 'CANCELLED - NOT PAID'
                      ? 'red'
                      : 'purple'
                }"
              >
                {{ (contract?.status || '-') | uppercase }}
              </div>
            </td>
            <td data-thead="Creation Method" [hidden]="!tableSelected['Creation Method']">{{ contract?.creation_source }}</td>
            <!-- <td *ngIf="(contract?.is_signed&&contract?.status!=='approved')" [hidden]="!tableSelected['Status']" data-thead="STATUS"><span class="status signed">signed</span></td>
                  <td *ngIf="(contract?.is_signed&&contract?.status==='approved')" [hidden]="!tableSelected['Status']" data-thead="STATUS"><span class="status">approved</span></td> -->
            <!-- <td data-thead="SELLER">Mazda of 46</td> -->
            <td data-thead="VIEW PDF">
              <img
                src="../../../../assets/images/file-text.svg"
                alt="View contract details"
                title="View contract details"
                style="cursor: pointer"
                (click)="viewContractDetails(contract?.id)"
              />
              <img
                src="../../../../assets/images/eye.svg"
                alt="Preview contract PDF"
                title="Preview contract PDF"
                style="cursor: pointer"
                (click)="previewContractDocument(contract?.id)"
              />
              <img
                *ngIf="
                  (contract?.status == 'new' || contract?.status == 'draft') &&
                  whoEntered != 'agent' &&
                  whoEntered != 'broker'
                "
                src="../../../../assets/images/ic-edit.png"
                alt="edit"
                style="cursor: pointer"
                (click)="setEditingContractState(contract?.id)"
              />
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="isLoading">
          <tr *ngFor="let load of Loading">
            <td class="checkbox-col" *ngIf="canShowBulkStatusChange">
              <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
            </td>
            <td
              class="contract-number"
              data-thead="Contract Number "
              [hidden]="!tableSelected['Contract Number']"
            >
              <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
            </td>
            <td
              class="contract-code"
              data-thead="Contract Code "
              [hidden]="!tableSelected['Contract Code']"
            >
              <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
            </td>
            <td
              data-thead="Product Name"
              [hidden]="!tableSelected['Product Name']"
            >
              <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
            </td>
            <!-- <td data-thead="CONTRACT TYPE" [hidden]="!tableSelected['Contract Type']"><ngx-skeleton-loader appearance="line"></ngx-skeleton-loader></td> -->
            <td data-thead="Dealer" [hidden]="!tableSelected['Dealer']">
              <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
            </td>
            <td
              data-thead="CUSTOMER NAME"
              [hidden]="!tableSelected['Customer Name']"
            >
              <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
            </td>
            <!-- <td data-thead="Phone #" [hidden]="!tableSelected['Phone']"><ngx-skeleton-loader appearance="line"></ngx-skeleton-loader></td> -->
            <td
              data-thead="CONTRACT DATE"
              [hidden]="!tableSelected['Contract Date']"
            >
              <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
            </td>
            <td
              data-thead="CONTRACT EXP. DATE"
              [hidden]="!tableSelected['Contract Exp. Date']"
            >
              <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
            </td>
            <td data-thead="Total Balance" [hidden]="!tableSelected['Total Balance']">
              <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
            </td>
            <td data-thead="Total Remit." [hidden]="!tableSelected['Total Remit.']">
              <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
            </td>
            <td data-thead="Retail Cost" [hidden]="!tableSelected['Retail Cost']">
              <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
            </td>
            <td data-thead="STATUS" [hidden]="!tableSelected['Status']">
              <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
            </td>
            <!-- <td data-thead="SELLER"><ngx-skeleton-loader appearance="line"></ngx-skeleton-loader></td> -->
            <td data-thead="VIEW PDF">
              <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
            </td>
          </tr>
        </tbody>
        <tbody
          *ngIf="!isLoading && contractData.length == 0 && !serverErrorFetch"
        >
          <tr>
            <td colspan="12" class="no-data">There Is No Data At The Moment</td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="serverErrorFetch" class="internal-server-error">
        {{ serverErrorFetch }}
      </div>
    </div>
    <app-paginator
      [total]="totalItems"
      [updateParams]="!isBrokerContractsPage"
      [currentPage]="currentPage"
      [rowsPerPage]="brokerContractPageSize"
      (paginationUpdated)="onBrokerContractPagination($event)"
    ></app-paginator>
  </div>
  </ng-template>

  <app-bulk-change-contract-status-modal
    *ngIf="canShowBulkStatusChange"
    [visible]="showBulkChangeStatusModal"
    [contractIds]="selectedContractIds"
    (visibleChange)="onBulkChangeStatusModalVisibilityChange($event)"
    (onConfirm)="onBulkStatusChangeConfirmed()"
  ></app-bulk-change-contract-status-modal>
</div>
